import { useState } from 'react';
import { syncSRAData } from '../services/organisationService';

export const useSync = () => {
  const [isSyncing, setIsSyncing] = useState(false);
  const [error, setError] = useState(null);

  const handleSync = async () => {
    setIsSyncing(true);
    setError(null);
    try {
      await syncSRAData();
      window.location.reload();
    } catch (err) {
      console.error('Error syncing data:', err);
      setError(err.response?.data?.details || 'Failed to sync SRA data');
    } finally {
      setIsSyncing(false);
    }
  };

  return {
    isSyncing,
    error,
    handleSync,
  };
}; 